import React, { useEffect, useState, } from "react";
import { TextField, withStyles, WithStyles } from "@material-ui/core";
import { styles } from "./BusinessPartnersTextField.styles";
import { isContentOK } from "../../../utilities/BusinessPartnersUtils";

type bpCheckErrors = "MAX_ISIN_EXCEEDED" | "INCORRECT_FORMAT";

const bpErrorTexts = {
    "INCORRECT_FORMAT": "Incorrect content"
};

export interface IBusinessPartner {
    bpId?: number;
    bpName: string;
    countryCode: string;
    countryName?: string;
}

export interface IBPOKCheck {
    result: boolean;
    businessPartners?: IBusinessPartner[];
    error?: bpCheckErrors;
}

export interface IBusinessPartnersTextFieldProps extends WithStyles<typeof styles> {
    disabled?: boolean;
    onChange?: (result: IBPOKCheck) => any;
}
const BusinessPartnersTextFieldPure: React.FunctionComponent<IBusinessPartnersTextFieldProps> = ({ onChange, disabled, classes }) => {
    
    const [text, setText] = useState<string>("");
    const [result, setResult] = useState<IBPOKCheck>();

    const handleFileUpload = event => {
        const file = event.target.files[0];
        event.target.value = '';
        const filereader = new FileReader();
        filereader.readAsText(file);
        filereader.onloadend = e => {
            const bpText = e.target.result as string;
            setText(bpText);
        };
    };

    useEffect(() => {
        const result = isContentOK(text?.trim());
        onChange(result);
        setResult(result);
        // eslint-disable-next-line
    }, [text]);
    

    const isError = !result?.result && text !== "";

    const getBPErrorText = (error: bpCheckErrors) => {
        return bpErrorTexts[error] || "Unknown error;"
    }
    return (
        <div>
            <TextField
                variant="outlined"
                style={{ width: "100%", backgroundColor: "white", marginBottom: 20}}
                multiline={true}
                rows={10}
                value={text}
                disabled={disabled}
                onChange={e =>  setText(e.target.value)}
                error={isError}
                helperText={isError ? getBPErrorText(result?.error) : ""}
            />
            <form>
                <input type="file" id="myFile" name="filename" accept=".csv,.txt" onChange={handleFileUpload} disabled={disabled} className={classes.filename}/>
            </form>
        </div>
    );
};

export const BusinessPartnersTextField = withStyles(styles)(BusinessPartnersTextFieldPure);
